import { TabulatorColumn, TabulatorRow } from "./types";

export const Formatter = {

	Link: {
		formatter: 'link',
		formatterParams: {
			url: 'javascript:void(0)'
		}
	} as Partial<TabulatorColumn>,

	RightAlign: {
		hozAlign: "right",
		titleFormatter: function (cell: any) {
			const element = cell.getElement();
			element.style.textAlign = 'right';
			element.style.padding = '0px 10px 0px 0px';
			return cell.getValue()
		}
	} as Partial<TabulatorColumn>,

	CenterAlign: {
		hozAlign: "center",
		titleFormatter: function (cell: any, formatterParams: any, onRendered: any) {
			const element = cell.getElement();
			element.style.textAlign = 'center';
			element.style.padding = '0px';
			return cell.getValue()
		}
	} as Partial<TabulatorColumn>,

	RowFormatter: (row: TabulatorRow) => {
		const element: HTMLElement = row.getElement();

		const findResponsiveTable = (childNodes: any) => {
			for (let i = 0; i < childNodes.length; i++) {
				const div = childNodes[i];
				if (div.className === 'tabulator-responsive-collapse') {
					if (div.children.length)
						return div.children[0];
					break;
				}
			}
			return undefined;
		}

		let responsiveTable = findResponsiveTable(element.children);
		if (responsiveTable) {

			//while(responsiveTable.firstChild) responsiveTable.removeChild(responsiveTable.firstChild);
			//return;
			if (responsiveTable.children.length === 1 && responsiveTable.children[0].localName === 'tbody')
				responsiveTable = responsiveTable.children[0];
			const row = responsiveTable.children;
			for (let i = 0; i < row.length; i++) {
				const col = row[i];
				col.removeChild(col.firstChild);
				//if( col.length===2)
				//    row.removeChild(col[0]);                
			}
		}
		//http://tabulator.info/examples/4.8
		//clear current row data
		//while(element.firstChild) element.removeChild(element.firstChild);
		// innerHTML = '<div class="tabulator-cell" role="gridcell" tabulator-field="Type" title="" style="width: 65px;"><div class="tabulator-col-resize-handle"></div><div class="tabulator-col-resize-handle prev"></div></div><div class="tabulator-cell" role="gridcell" tabulator-field="Url" title="" style="width: 181px; display: none;"><a href="javascript:void(0)">http://localhost:8080/two</a><div class="tabulator-col-resize-handle"></div><div class="tabulator-col-resize-handle prev"></div></div><div class="tabulator-…-45ed-9ad9-0004a9b24d8e<div class="tabulator-col-resize-handle"></div><div class="tabulator-col-resize-handle prev"></div></div><div class="tabulator-responsive-collapse"><table><tbody><tr><td><strong>Url</strong></td><td><a href="javascript:void(0)">http://localhost:8080/two</a></td></tr><tr><td><strong>Subscriptions</strong></td><td><b><a href="/subscription/817a1539-6119-456b-bc34-14777ac6ee2e">Core</a></b> (<span style="color:blue;">unlimited licence</span>)</td></tr></tbody></table></div>'
	}
}
